/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AcceptInviteRouteImport } from './routes/accept-invite'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppTrackingRouteImport } from './routes/app/tracking'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppOrdersRouteImport } from './routes/app/orders'
import { Route as AppInventoryRouteImport } from './routes/app/inventory'
import { Route as AppAnalyticsRouteImport } from './routes/app/analytics'
import { Route as AppAdminRouteImport } from './routes/app/admin'
import { Route as AppIntegrationsRouteRouteImport } from './routes/app/integrations/route'
import { Route as AppIntegrationsIndexRouteImport } from './routes/app/integrations/index'
import { Route as AppOrdersOrderIdRouteImport } from './routes/app/orders_.$orderId'
import { Route as AppIntegrationsConnectRouteImport } from './routes/app/integrations/connect'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTrackingRoute = AppTrackingRouteImport.update({
  id: '/tracking',
  path: '/tracking',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOrdersRoute = AppOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppInventoryRoute = AppInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppIntegrationsRouteRoute = AppIntegrationsRouteRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppIntegrationsIndexRoute = AppIntegrationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppIntegrationsRouteRoute,
} as any)
const AppOrdersOrderIdRoute = AppOrdersOrderIdRouteImport.update({
  id: '/orders_/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppIntegrationsConnectRoute = AppIntegrationsConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => AppIntegrationsRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/app/integrations': typeof AppIntegrationsRouteRouteWithChildren
  '/app/admin': typeof AppAdminRoute
  '/app/analytics': typeof AppAnalyticsRoute
  '/app/inventory': typeof AppInventoryRoute
  '/app/orders': typeof AppOrdersRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/tracking': typeof AppTrackingRoute
  '/app/': typeof AppIndexRoute
  '/app/integrations/connect': typeof AppIntegrationsConnectRoute
  '/app/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/app/integrations/': typeof AppIntegrationsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/app/admin': typeof AppAdminRoute
  '/app/analytics': typeof AppAnalyticsRoute
  '/app/inventory': typeof AppInventoryRoute
  '/app/orders': typeof AppOrdersRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/tracking': typeof AppTrackingRoute
  '/app': typeof AppIndexRoute
  '/app/integrations/connect': typeof AppIntegrationsConnectRoute
  '/app/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/app/integrations': typeof AppIntegrationsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/accept-invite': typeof AcceptInviteRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/app/integrations': typeof AppIntegrationsRouteRouteWithChildren
  '/app/admin': typeof AppAdminRoute
  '/app/analytics': typeof AppAnalyticsRoute
  '/app/inventory': typeof AppInventoryRoute
  '/app/orders': typeof AppOrdersRoute
  '/app/settings': typeof AppSettingsRoute
  '/app/tracking': typeof AppTrackingRoute
  '/app/': typeof AppIndexRoute
  '/app/integrations/connect': typeof AppIntegrationsConnectRoute
  '/app/orders_/$orderId': typeof AppOrdersOrderIdRoute
  '/app/integrations/': typeof AppIntegrationsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/accept-invite'
    | '/login'
    | '/signup'
    | '/app/integrations'
    | '/app/admin'
    | '/app/analytics'
    | '/app/inventory'
    | '/app/orders'
    | '/app/settings'
    | '/app/tracking'
    | '/app/'
    | '/app/integrations/connect'
    | '/app/orders/$orderId'
    | '/app/integrations/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invite'
    | '/login'
    | '/signup'
    | '/app/admin'
    | '/app/analytics'
    | '/app/inventory'
    | '/app/orders'
    | '/app/settings'
    | '/app/tracking'
    | '/app'
    | '/app/integrations/connect'
    | '/app/orders/$orderId'
    | '/app/integrations'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/accept-invite'
    | '/login'
    | '/signup'
    | '/app/integrations'
    | '/app/admin'
    | '/app/analytics'
    | '/app/inventory'
    | '/app/orders'
    | '/app/settings'
    | '/app/tracking'
    | '/app/'
    | '/app/integrations/connect'
    | '/app/orders_/$orderId'
    | '/app/integrations/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AcceptInviteRoute: typeof AcceptInviteRoute
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/tracking': {
      id: '/app/tracking'
      path: '/tracking'
      fullPath: '/app/tracking'
      preLoaderRoute: typeof AppTrackingRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/orders': {
      id: '/app/orders'
      path: '/orders'
      fullPath: '/app/orders'
      preLoaderRoute: typeof AppOrdersRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/inventory': {
      id: '/app/inventory'
      path: '/inventory'
      fullPath: '/app/inventory'
      preLoaderRoute: typeof AppInventoryRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/analytics': {
      id: '/app/analytics'
      path: '/analytics'
      fullPath: '/app/analytics'
      preLoaderRoute: typeof AppAnalyticsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/admin': {
      id: '/app/admin'
      path: '/admin'
      fullPath: '/app/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/integrations': {
      id: '/app/integrations'
      path: '/integrations'
      fullPath: '/app/integrations'
      preLoaderRoute: typeof AppIntegrationsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/integrations/': {
      id: '/app/integrations/'
      path: '/'
      fullPath: '/app/integrations/'
      preLoaderRoute: typeof AppIntegrationsIndexRouteImport
      parentRoute: typeof AppIntegrationsRouteRoute
    }
    '/app/orders_/$orderId': {
      id: '/app/orders_/$orderId'
      path: '/orders/$orderId'
      fullPath: '/app/orders/$orderId'
      preLoaderRoute: typeof AppOrdersOrderIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/integrations/connect': {
      id: '/app/integrations/connect'
      path: '/connect'
      fullPath: '/app/integrations/connect'
      preLoaderRoute: typeof AppIntegrationsConnectRouteImport
      parentRoute: typeof AppIntegrationsRouteRoute
    }
  }
}

interface AppIntegrationsRouteRouteChildren {
  AppIntegrationsConnectRoute: typeof AppIntegrationsConnectRoute
  AppIntegrationsIndexRoute: typeof AppIntegrationsIndexRoute
}

const AppIntegrationsRouteRouteChildren: AppIntegrationsRouteRouteChildren = {
  AppIntegrationsConnectRoute: AppIntegrationsConnectRoute,
  AppIntegrationsIndexRoute: AppIntegrationsIndexRoute,
}

const AppIntegrationsRouteRouteWithChildren =
  AppIntegrationsRouteRoute._addFileChildren(AppIntegrationsRouteRouteChildren)

interface AppRouteRouteChildren {
  AppIntegrationsRouteRoute: typeof AppIntegrationsRouteRouteWithChildren
  AppAdminRoute: typeof AppAdminRoute
  AppAnalyticsRoute: typeof AppAnalyticsRoute
  AppInventoryRoute: typeof AppInventoryRoute
  AppOrdersRoute: typeof AppOrdersRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTrackingRoute: typeof AppTrackingRoute
  AppIndexRoute: typeof AppIndexRoute
  AppOrdersOrderIdRoute: typeof AppOrdersOrderIdRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppIntegrationsRouteRoute: AppIntegrationsRouteRouteWithChildren,
  AppAdminRoute: AppAdminRoute,
  AppAnalyticsRoute: AppAnalyticsRoute,
  AppInventoryRoute: AppInventoryRoute,
  AppOrdersRoute: AppOrdersRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTrackingRoute: AppTrackingRoute,
  AppIndexRoute: AppIndexRoute,
  AppOrdersOrderIdRoute: AppOrdersOrderIdRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
